export const SPRING_OFFER_YEAR = 2026;

export const SPRING_OFFER_RANGES = {
	prod: {
		start: `${SPRING_OFFER_YEAR}-04-01T00:00:00+02:00`,
		end: `${SPRING_OFFER_YEAR}-05-20T23:59:59+02:00`,
	},
	accept: {
		start: `${SPRING_OFFER_YEAR}-03-01T00:00:00+01:00`,
		end: `${SPRING_OFFER_YEAR}-04-20T23:59:59+02:00`,
	},
} as const;

export const SPRING_OFFER_TRANSLATION_VALUES = {
	year: SPRING_OFFER_YEAR,
} as const;
